import React from 'react';
import CouponForm from './form';
import {getCouponItem, updateCouponItem} from '../../modules/Api';
import {normalizer, prepareForEdit} from './pipeline';
import {notification} from 'antd';
import history from '../../modules/History';

class EditCoupon extends React.Component {
    constructor() {
        super();
        this.state = {
            data: {},
            submitted: false
        }
        
    }
    componentDidMount() {
        this.fetchCouponDetail();
    }
    fetchCouponDetail() {
        const couponId = this.props.match.params.id;
        getCouponItem(couponId, data => {this.setState({data: prepareForEdit(data)})});
    }
    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        const couponId = this.props.match.params.id;
        const formData = normalizer(values, this.state.data);
        updateCouponItem(couponId, formData, () => {
            notification.open({
                message: `کوپن با موفقیت ویرایش شد!`,
                description: ``
            });
            this.setState({submitted: false});
            history.item.push(`/coupons`);
        })
    }
    render() {
        if(!this.state.data.id){
            return (<div>لطفا منتظر بمانید</div>);
        }
        return (<div><CouponForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>);
    }
}

export default EditCoupon;


// WEBPACK FOOTER //
// ./src/containers/Coupons/edit.js